import { monetizationApi } from "../store/api/monetizationApi";
import { runMutation, runQueryNoArg } from "../store/api/runtime";
import type {
  BoostQuote,
  DowngradeToFreeResponse,
  MonetizationMe,
  PaypalBoostOrderResponse,
  PlanSummary,
} from "../store/api/monetizationApi";

export type { PlanSummary, MonetizationMe, BoostQuote };

export async function getPlans(): Promise<PlanSummary[]> {
  return runQueryNoArg(monetizationApi.endpoints.getPlans.initiate);
}

export async function getMonetizationMe(): Promise<MonetizationMe> {
  return runQueryNoArg(monetizationApi.endpoints.getMonetizationMe.initiate);
}

export async function selectFreePlan(): Promise<{ message: string; activePlanCode: string; planSelectionCompleted: boolean }> {
  return runMutation(monetizationApi.endpoints.selectFreePlan.initiate, undefined);
}

export async function activatePaypalSubscription(payload: { subscriptionId: string; planCode?: "free" | "pro" | "elite" }) {
  return runMutation(monetizationApi.endpoints.activatePaypalSubscription.initiate, payload);
}

export async function downgradePaypalSubscriptionToFree(): Promise<DowngradeToFreeResponse> {
  return runMutation(monetizationApi.endpoints.downgradePaypalSubscriptionToFree.initiate, undefined);
}

export async function quoteBoost(payload: { postType: "trade" | "bounty"; postId: string }): Promise<BoostQuote> {
  return runMutation(monetizationApi.endpoints.quoteBoost.initiate, payload);
}

export async function applyFreeBoost(payload: { postType: "trade" | "bounty"; postId: string }) {
  return runMutation(monetizationApi.endpoints.applyFreeBoost.initiate, payload);
}

export async function createBoostOrder(payload: { postType: "trade" | "bounty"; postId: string }): Promise<PaypalBoostOrderResponse> {
  return runMutation(monetizationApi.endpoints.createBoostOrder.initiate, payload);
}

export async function captureBoostOrder(payload: { orderId: string; postType: "trade" | "bounty"; postId: string }) {
  return runMutation(monetizationApi.endpoints.captureBoostOrder.initiate, payload);
}

export async function updateProfileTheme(theme: string) {
  return runMutation(monetizationApi.endpoints.updateProfileTheme.initiate, { theme });
}
